export const COMMON_LINK_CLASS_NAME = `min-w-[40px] min-h-[40px] flex items-center justify-center gap-2 px-4 py-2.5
text-neutral-900 md-medium rounded-lg hover:bg-mercury-200 hover:no-underline
transition-colors duration-quicker ease-out`;
